import { I18n } from '@calendly/i18n';
import { AlertWarningTriangleIcon, ArrowChevronDownIcon, ArrowChevronUpIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import { HtmlParser } from '@calendly/ui/utils/html-parser';
import classNames from 'classnames';
import { nanoid } from 'nanoid';
import { useState, forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { closePollsBookingModal } from 'actions/polls/scheduling';
const wrapperCss = "w12qubmg";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const bannerIsExternalConflictCss = "bwuiiuw";
const bannerIsExpandedCss = "bjjg376";
const bannerCss = "bpc08y1";
const Banner = forwardRef((props, ref) => {
  const {
    isExternalConflict,
    isExpanded,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bannerCss, {
    [bannerIsExternalConflictCss]: isExternalConflict,
    [bannerIsExpandedCss]: isExpanded
  }, props.className)} />;
});
const expandedItemCss = "ekasnfq";
const ExpandedItem = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(expandedItemCss, props.className)} />;
});
const detailsCss = "dkgwca3";
const Details = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(detailsCss, props.className)} />;
});
const ExternalConflictBanner = () => <Wrapper>
    <Banner isExternalConflict>
      <AlertWarningTriangleIcon inline spacingRight={8} />
      {I18n.t('publisher.scheduled_events.pending.booking_modal.event_conflict_warning')}
    </Banner>
  </Wrapper>;
const InternalConflictBanner = ({
  internalConflictEvents
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isExpanded, setIsExpanded] = useState(false);
  const onClickLink = (e, url) => {
    e.preventDefault();
    history.push(url);
    dispatch(closePollsBookingModal());
  };
  return <Wrapper>
      <Banner isExpanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
        <div>
          <AlertWarningTriangleIcon inline spacingRight={8} />
          {HtmlParser(I18n.t('booking.conflicts.header', {
          count: internalConflictEvents.length
        }))}
        </div>
        {isExpanded ? <ArrowChevronUpIcon inline /> : <ArrowChevronDownIcon inline />}
      </Banner>
      {isExpanded && <>
          {internalConflictEvents.map(({
        event_name: eventName,
        start_time: startTime,
        end_time: endTime,
        view_link: viewLink
      }) => {
        const url = viewLink.substring(viewLink.indexOf('/app'));
        return <ExpandedItem key={nanoid(5)}>
                <Details>
                  <div>{HtmlParser(eventName)}</div>
                  <div>{`${startTime} - ${endTime}`}</div>
                </Details>
                <Link href={viewLink} onClick={e => onClickLink(e, url)}>
                  {I18n.t('publisher.booking_modal.view')}
                </Link>
              </ExpandedItem>;
      })}
        </>}
    </Wrapper>;
};
export const WarningBanner = ({
  hasExternalEventConflict,
  internalConflictEvents
}) => {
  const hasBothConflicts = hasExternalEventConflict && internalConflictEvents?.length;
  if (internalConflictEvents?.length || hasBothConflicts) {
    return <InternalConflictBanner internalConflictEvents={internalConflictEvents} />;
  }
  if (hasExternalEventConflict) {
    return <ExternalConflictBanner />;
  }
  return null;
};

require("./warning_banner.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./warning_banner.js");